// components/OBE/OBEConfig.jsx
import React, { useState, useEffect } from 'react';
import CourseOutcome from './CourseOutcome';
import CoPoMapping from './CoPoMapping';
import { FiBook, FiLink, FiSettings } from 'react-icons/fi';

const OBEConfig = ({ branch }) => {
  const [activeTab, setActiveTab] = useState('course-outcomes');

  const tabs = [
    { 
      id: 'course-outcomes', 
      label: 'Course Outcomes', 
      icon: <FiBook className="w-5 h-5" />,
      description: 'Define and manage Course Outcomes for subjects'
    },
    { 
      id: 'co-po-mapping', 
      label: 'CO-PO Mapping', 
      icon: <FiLink className="w-5 h-5" />,
      description: 'Map Course Outcomes to Program Outcomes'
    },
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'course-outcomes':
        return <CourseOutcome branch={branch} />;
      case 'co-po-mapping':
        return <CoPoMapping branch={branch} />;
      default:
        return <CourseOutcome branch={branch} />;
    }
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="bento-header-banner flex items-center justify-between">
        <div>
          <h1 className="text-xl font-bold tracking-tight text-slate-900 dark:text-white flex items-center gap-2">
            <FiSettings className="text-indigo-600 dark:text-indigo-400" /> OBE Configuration
          </h1>
          <p className="text-slate-500 dark:text-slate-400 font-medium text-xs mt-0.5">Outcome Based Education Management System</p>
        </div>
      </div>

      {/* Tab Navigation */}
      <div className="bento-card p-1.5 bg-slate-100 dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-2xl">
        <div className="grid grid-cols-2 gap-2">
          {tabs.map(tab => (
            <button
              key={tab.id}
              className={`px-4 py-2.5 rounded-xl font-bold text-xs transition cursor-pointer flex items-center justify-center gap-2 ${
                activeTab === tab.id 
                  ? 'bg-white dark:bg-slate-800 text-indigo-600 dark:text-indigo-400 shadow-xs border border-slate-200/60 dark:border-slate-700'
                  : 'text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white'
              }`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.icon}
              <span>{tab.label}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Tab Content */}
      <div className="bg-white dark:bg-slate-900 rounded-2xl shadow-xs border border-slate-200 dark:border-slate-800 p-6">
        {renderTabContent()}
      </div>
    </div>
  );
};

export default OBEConfig;